import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Notifier, LinkText } from "../ecosystem";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const MedicationsBanner = ({ hasMyChart, rxProxySubject, isMyChartProxy }) => {
    return (
        <div className="row meds-moving-notifier">
            <div className="col-12">
                {!rxProxySubject
                    ? hasMyChart
                        ? <Notifier icon="alert" link={{
                            label: "Go to Medications",
                            to: { pathname: '/currentmeds' },
                            onClick: () => logUI("MBHWeb.UI.RX.MedicationsBanner.Medications.Click", new Date(), Tools.getURLPath())
                        }}
                        >
                            Our pharmacy is migrating to a new section. If you don't see your medications, you can now find them in the Medications section.
                        </Notifier>
                        : <Notifier icon="exclamation" colorStyle="error">
                            Our pharmacy is migrating to a new section. To access your medications, call us at{' '}
                            <LinkText href="tel:855.691.0180" typographyType="body-02" color="$color-secondary-a1" underline="always">855.691.0180</LinkText> to link your medical records.
                        </Notifier>
                    : isMyChartProxy
                        ? <Notifier icon="alert" link={{
                            label: "Go to Medications",
                            to: { pathname: '/familyselection/rxcurrentmeds' },
                            onClick: () => logUI("MBHWeb.UI.RX.MedicationsBanner.Medications.Click", new Date(), Tools.getURLPath())
                        }}
                        >
                            Our pharmacy is migrating to a new section. If you don't see your medications, you can now find them in the Medications section.
                        </Notifier>
                        : hasMyChart
                            ? <Notifier icon="exclamation" colorStyle="error" link={{
                                label: "Request access",
                                to: { pathname: '/proxyrequestDOB' },
                                onClick: () => logUI("MBHWeb.UI.RX.MedicationsBanner.proxyrequestDOB.Click", new Date(), Tools.getURLPath())
                            }}
                            >
                                Our pharmacy is migrating to a new Medications section. If you don't see {rxProxySubject.fn}'s medications,{' '}
                                you can request access to their medical records to view them.
                            </Notifier>
                            : <Notifier icon="exclamation" colorStyle="error">
                                Our pharmacy is migrating to a new Medications section. If you don't see {rxProxySubject.fn}'s medications, you can call us at{' '}
                                <LinkText href="tel:855.691.0180" typographyType="body-02" color="$color-secondary-a1" underline="always">855.691.0180</LinkText> to link your medical records and then request access to their medications in{' '}
                                <LinkText to={{ pathname: '/proxyrequestDOB' }} typographyType="body-02" color="$color-secondary-a1" underline="always" onClick={() => logUI("MBHWeb.UI.RX.MedicationsBanner.proxyrequestDOB.Click", new Date(), Tools.getURLPath())}>family management.</LinkText>
                            </Notifier>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    const pl = state.domain.pl;
    return {
        hasMyChart: state.domain.hm,
        rxProxySubject: state.domain.cpu,
        isMyChartProxy: pl && pl.length > 1
    };
};

/*const mapDispatchToProps = (dispatch) => {
    return {
    };
};*/

export default connect(mapStateToProps/*, mapDispatchToProps*/)(MedicationsBanner);